<form [formGroup]="userForm" (ngSubmit)="onSave()" class="create-user-form">
  <h2>Crear Nuevo Usuario</h2>

  <div class="form-field">
    <label for="name">Nombre</label>
    <input id="name" type="text" formControlName="name" placeholder="Nombre del usuario">
    <div *ngIf="userForm.get('name')?.invalid && userForm.get('name')?.touched" class="error-message">
      El nombre es obligatorio.
    </div>
  </div>

  <div class="form-row">
    <div class="form-field">
      <label for="firstSurname">Primer Apellido</label>
      <input id="firstSurname" type="text" formControlName="firstSurname" placeholder="Primer apellido">
      <div *ngIf="userForm.get('firstSurname')?.invalid && userForm.get('firstSurname')?.touched" class="error-message">
        El primer apellido es obligatorio.
      </div>
    </div>
    <div class="form-field">
      <label for="secondSurname">Segundo Apellido (Opcional)</label>
      <input id="secondSurname" type="text" formControlName="secondSurname" placeholder="Segundo apellido">
    </div>
  </div>

  <div class="form-field">
    <label for="email">Email</label>
    <input id="email" type="email" formControlName="email" placeholder="correo@ejemplo.com">
    <div *ngIf="userForm.get('email')?.invalid && userForm.get('email')?.touched" class="error-message">
      <span *ngIf="userForm.get('email')?.errors?.['required']">El email es obligatorio.</span>
      <span *ngIf="userForm.get('email')?.errors?.['email']">El formato del email no es válido.</span>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field">
      <label for="nif">NIF / NIE</label>
      <input id="nif" type="text" formControlName="nif" placeholder="12345678A">
      <div *ngIf="userForm.get('nif')?.invalid && userForm.get('nif')?.touched" class="error-message">
        <span *ngIf="userForm.get('nif')?.errors?.['required']">El NIF/NIE es obligatorio cuando no se usa identificador alternativo.</span>
        <span *ngIf="userForm.get('nif')?.errors?.['minlength']">El identificador debe tener al menos 3 caracteres.</span>
        <span *ngIf="userForm.get('nif')?.errors?.['maxlength']">El identificador no puede superar 32 caracteres.</span>
      </div>
    </div>
    <div class="form-field checkbox-field">
      <label for="useAlternativeIdentifier">Identificador internacional alternativo</label>
      <div class="checkbox-control">
        <input id="useAlternativeIdentifier" type="checkbox" formControlName="useAlternativeIdentifier">
        <span>Permitir alta sin NIF español</span>
      </div>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field">
      <label for="countryIsoCode">País</label>
      <select id="countryIsoCode" formControlName="countryIsoCode">
        <option *ngFor="let country of countries" [value]="country.iso_code">
          {{ country.name }} ({{ country.iso_code }}) {{ country.phone_prefix || '' }}
        </option>
      </select>
    </div>
    <div class="form-field">
      <label for="telephone">Teléfono (Opcional)</label>
      <input id="telephone" type="tel" formControlName="telephone" placeholder="912345678">
      <div *ngIf="userForm.get('telephone')?.invalid && userForm.get('telephone')?.touched" class="error-message">
        El formato del teléfono no es válido (solo dígitos, 6-14).
      </div>
    </div>
  </div>

  <div class="form-actions">
    <app-rfebm-secondary-button (onClick)="onCancel()">
      Cancelar
    </app-rfebm-secondary-button>

    <app-rfebm-primary-button [isDisabled]="userForm.invalid" (click)="onSave()">
      Crear Usuario
    </app-rfebm-primary-button>
  </div>
</form>
